var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tariff-zone',{ref:"tariffZone",attrs:{"type":_vm.partnerType,"transport":_vm.tarificationTransport}})}
var staticRenderFns = []

export { render, staticRenderFns }